const bubble2 = (color) => `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 455.9 455.9" style="enable-background:new 0 0 455.9 455.9;" xml:space="preserve">
<style type="text/css">
\t.st0{fill:${color};}
\t.st1{fill:#FFFFFF;}
\t#ls-openButton:hover .st0 { fill:#FFFFFF;}
\t#ls-openButton:hover .st1{ fill:${color};}
</style>
<circle class="st0" cx="228" cy="228" r="228"/>
<path class="st1" d="M150.2,336c-5.3,0-10.6-0.5-15.8-1.5c-12.4-2.3-24.3-7.1-34.9-14l-15.9-11.4l19.1,0.9
\tc10.5,0.5,19.7-6.7,27.5-21.6c-13.7-9.3-25.3-21.3-34-35.4c-9.4-15.4-14.5-33-14.5-51.1c0-29.9,13.7-57.9,38.6-78.9
\tc24.5-20.7,57-32,91.5-32s67,11.4,91.5,32c24.9,21,38.6,49,38.6,78.9s-13.7,57.9-38.6,78.9c-24.5,20.7-57,32-91.5,32
\tc-1.3,0-2.6,0-4-0.1C187.5,330.9,167,336,150.2,336z M118.3,317.8c5.9,2.5,12,4.3,18.2,5.5c24.2,4.4,46.3-2.5,65.8-20.5l1.6-1.5
\tl2.1,0.1c2,0.1,3.8,0.1,5.7,0.1c65.9,0,119.5-44.7,119.5-99.5s-53.6-99.5-119.4-99.5S92.3,147.1,92.3,202
\tc0,31.5,17.3,60.4,47.6,79.5l4.2,2.7l-2.2,4.8C135.3,303.3,127.4,313,118.3,317.8z"/>
<path class="st1" d="M361.1,317.8c18.1-10.8,29.8-27.9,29.8-47.3c0-24.2-18.4-45.1-44.7-54.1c-2.8,43.6-37.2,80.2-84.2,93.7
\tc13.5,11.9,33.1,19.4,54.8,19.4c1.2,0,2.3,0,3.5-0.1c29.8,26.1,61.3,4.8,61.3,4.8C372.3,334.7,365.7,327.3,361.1,317.8z"/>
<path class="st1" d="M280,151.3H148.2c-5.1,0-9.4,5-9.4,11.2l0,0c0,6.2,4.2,11.2,9.4,11.2H280c5.1,0,9.4-5,9.4-11.2l0,0
\tC289.3,156.4,285.1,151.3,280,151.3z"/>
<path class="st1" d="M148.2,211.1h97.5c5.1,0,9.4-5,9.4-11.2l0,0c0-6.2-4.2-11.2-9.4-11.2h-97.5c-5.1,0-9.4,5-9.4,11.2l0,0
\tC138.8,206.1,143,211.1,148.2,211.1z"/>
<path class="st1" d="M279.2,227H147.4c-5.1,0-9.4,5-9.4,11.2l0,0c0,6.2,4.2,11.2,9.4,11.2h131.8c5.1,0,9.3-5,9.3-11.2l0,0
\tC288.6,232.1,284.4,227,279.2,227z"/>
</svg>
`
export default bubble2;



//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble2.js
// module id = null
// module chunks = 